module.exports = __webpack_public_path__ + "media/src/img/mob-frame-rh-86db6e3638e40b3717b2cb62a5caeb9f.png";